import * as getters from "../../baseQuestion/searchableStaticDDL/store/getters";
import * as mutations from "../../baseQuestion/searchableStaticDDL/store/mutations";
import * as actions from "../../baseQuestion/searchableStaticDDL/store/actions";
import { state as searchable_static_ddl_state } from "../../baseQuestion/searchableStaticDDL/store/state";

function state() {
	return Object.assign(
		{
			multi_field_parent: "q_clubs",
			options: [
				{
					value: "CLB001",
					text: "Academic Club"
				},
				{
					value: "ATH010",
					text: "Athletics Club"
				},
				{
					value: "CLB007",
					text: "Computer Club"
				},
				{
					value: "CLB006",
					text: "Cultural Club"
				},
				{
					value: "OTH007",
					text: "Environmental Club"
				},
				{
					value: "OTH010",
					text: "Family Responsibilities"
				},
				{
					value: "CLB002",
					text: "Foreign Exchange"
				},
				{
					value: "CLB004",
					text: "Foreign Language"
				},
				{
					value: "CL4290",
					text: "Greek Club"
				},
				{
					value: "LDR005",
					text: "JR ROTC"
				},
				{
					value: "CL5223",
					text: "LGBTQ"
				},
				{
					value: "CLB999",
					text: "Other - Club"
				},
				{
					value: "GOV001",
					text: "Politics"
				},
				{
					value: "CLB009",
					text: "Research"
				},
				{
					value: "CLB008",
					text: "Robotics"
				},
				{
					value: "CLB005",
					text: "School Spirit"
				},
				{
					value: "CLB003",
					text: "Science/Math Club"
				},
				{
					value: "CLB011",
					text: "Social Justice Club"
				},
				{
					value: "OTH008",
					text: "Study Abroad"
				}
			]
		},
		searchable_static_ddl_state()
	);
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
};
